import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import { SuccessBadge } from "src/components/FreeboardingBadge";
import { FreeboardingGradientTitle } from "src/components/FreeboardingGradientTitle";
import { FreeboardingParagraph } from "src/components/FreeboardingParagraph";
import { FreeboardingSubtitle } from "src/components/FreeboardingSubtitle";
import { FreeboardingTitle } from "src/components/FreeboardingTitle";
import InviteLink from "src/components/InviteLink";
import SocialShareRow from "src/components/sharing/SocialShareRow";
import { TeamAvatar } from "src/components/TeamAvatar";
import { theme } from "src/theme/theme";
import { getAvatarLetters } from "src/utils/teamUtils";

interface LinkSharingPageProps {
  chipText: string;
  titleText: string;
  teamName: string;
  bodyText: string;
  shareMessage: string | undefined;
  link: string;
}

const LinkSharingPageComponent = ({
  chipText,
  titleText,
  teamName,
  bodyText,
  shareMessage,
  link,
}: LinkSharingPageProps) => {
  return (
    <Box
      display="flex"
      maxWidth="420px"
      flexDirection="column"
      alignItems="center"
      width="100%"
      height="100%"
    >
      <SuccessBadge label={chipText} />
      <FreeboardingTitle
        sx={{
          marginBottom: 0,
        }}
      >
        {titleText}
      </FreeboardingTitle>
      <FreeboardingGradientTitle
        sx={{
          marginTop: 0,
        }}
      >
        {teamName}
      </FreeboardingGradientTitle>
      <FreeboardingParagraph>{bodyText}</FreeboardingParagraph>
      <Box
        sx={{ marginTop: 2 }}
        display="flex"
        flexDirection="row"
        justifyContent="center"
        gap={-1}
      >
        <TeamAvatar sx={{ height: 88, width: 88, border: "3px solid white" }}>
          {getAvatarLetters(teamName || "")}
        </TeamAvatar>
        <TeamAvatar
          sx={{
            height: 88,
            width: 88,
            marginLeft: theme.spacing(-2),
            border: "3px solid white",
          }}
        >
          <AddIcon />
        </TeamAvatar>
      </Box>
      <FreeboardingSubtitle>Team invite link</FreeboardingSubtitle>
      <InviteLink link={link} />
      <FreeboardingParagraph>or share directly via:</FreeboardingParagraph>
      <SocialShareRow url={link} text={shareMessage} hashtags={""} />
    </Box>
  );
};

export default LinkSharingPageComponent;
